import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { getShouldNotifyBugSnag } from '@/helpers/bugsnag';

const IGNORED_MESSAGES = [
  'Network Error',
  'Failed to fetch',
  'Request aborted',
  'Unable to preload CSS for',
  'error loading dynamically imported module',
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
];

export default function () {
  let environment = '';
  if (process.env.NODE_ENV === 'development') {
    environment = 'development';
  } else if (window.location.hostname === 'my.assessfirst.com') {
    environment = 'production';
  } else {
    environment = 'test';
  }

  Bugsnag.start({
    apiKey: 'dbdc1e11bebf1c6646d0c195a5d64099',
    plugins: [new BugsnagPluginVue()],
    enabledReleaseStages: ['production'],
    releaseStage: environment,
    onError(event) {
      // Filter from message
      const errorMessage =
        typeof event?.originalError === 'string'
          ? event.originalError
          : event?.originalError?.message;

      const shouldIgnoreFromMessage =
        typeof errorMessage === 'string' &&
        IGNORED_MESSAGES.some((message) => errorMessage.includes(message));

      // Filter via the helper (status codes + error codes)
      const shouldIgnoreFromResponse =
        event.originalError?.response && !getShouldNotifyBugSnag(event.originalError.response);

      if (shouldIgnoreFromMessage || shouldIgnoreFromResponse) {
        return false;
      }
    },
  });
}
